// extracted by mini-css-extract-plugin
export var currencyInput = "_j6-1";
export var currencySymbol = "_j6-0";